import { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';

import { createServiceInstance } from '../baseService';
import { IValidateHmacRequest, IValidateHmacResponse } from './hmacServiceTypes';

/**
 * HMAC Validation model
 *
 * @description Returns object with user services
 * @typedef {object} IHmacService
 */
export interface IHmacService {
  validateHmac: (request: IValidateHmacRequest) => Promise<AxiosResponse<IValidateHmacResponse>> | null;
}

/**
 * User service hook
 * @description Gives access to all services relating to user
 */
const useHmacService = (): IHmacService => {
  const token = useSelector((state: any) => state.B2CSettings.items.accesstokenForms);
  const webappurlFormsApi = useSelector((state: any) => state.B2CSettings.items.webappurlFormsApi);

  const getInstance = () => createServiceInstance(`${webappurlFormsApi}/api/myCASA/Forms`, token);

  /**
   * Validate HMAC
   *
   * @description Validate HMAC
   * @param {IValidateHmacRequest} request Validate HMAC request
   * @returns {Promise<AxiosResponse<IValidateHmacResponse>>} Validate HMAC axios response
   */
  const validateHmac = (request: IValidateHmacRequest): Promise<AxiosResponse<IValidateHmacResponse>> => {
    const axiosInstance = getInstance();

    return axiosInstance.post<IValidateHmacResponse>('/validateHmac/v1', request);
  };

  return {
    validateHmac
  };
};

export default useHmacService;